export default __webpack_public_path__ + "static/brcc-image-left-1-mobile-8d8bb851b50b682861f32b21901a49ec.webp";